

import { createContext, useContext } from 'react';


export type OrientationValue = 'left' | 'right' | 'top' | 'bottom' | 'unknown';


interface OrientationContextType {
	orientation: OrientationValue;
	sensorOrientation: OrientationValue;
	windowOrientation: OrientationValue;
	enableOrientation: () => void;
}


const OrientationContext = createContext<OrientationContextType | null>(null);


export const useOrientation = () => {
	const context = useContext(OrientationContext);
	if (context === null) throw new Error('useOrientation must be used within an OrientationProvider');
	// Allow destructuring: const { enableOrientation, orientation } = useOrientation();
	return {
		enableOrientation: context.enableOrientation,
		orientation: context.orientation,
		sensorOrientation: context.sensorOrientation,
		windowOrientation: context.windowOrientation,
	};
};

export default OrientationContext;
